import React, {useEffect, useRef, useState} from 'react';
import './App.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios'
import SideBar from "./components/sidebar/SideBar";
import PieChartComponent from "./components/charts/pieCharts/PieChart";
import Headers from "./components/headers/Headers";
import {addClass, dateFormat, removeClass, subDays, toggleClass} from "./common";
import LineChartComponent from "./components/charts/lineCharts/LineChart";
import {getRequest} from "./network";
import UserTable from "./components/userTable/userTable";

function App(props) {
    const [lineChartData, setLineChartData] = useState([]);
    const [periodValue, setPeriodValue] = useState(5);
    const [startDate, setStartDate] = useState(subDays(new Date(), 7));
    const [endDate, setEndDate] = useState(new Date());
    const [userIdData, setUserIdData] = useState([]);
    const [sourceType, setSourceType] = useState([1]);
    const [dataBySource, setDataBySource] = useState([]);
    const [dataByType, setDataByType] = useState([]);
    const [totalUser, setTotalUser] = useState(0);
    const [mappedUserData, setMappedUserData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    let deviceRef = useRef(null);
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF6542', '#FFF532', '#FF0542', '#FF1022'];
    useEffect(() => {
        onDeviceTypeClicked();
        handleSummaryReportWithRange()
        handlePieData()
    }, []);
    useEffect(() => {

    }, []);
    function handleSummaryReportWithRange() {
        axios.get(`https://devua.indianexpress.com/api/reports/getsummaryreport/?startdate=${dateFormat(startDate, 'Y-m-d', '-')}&enddate=${dateFormat(endDate, 'Y-m-d', '-')}`).then(res => {
            if (res.status === 200 || res.status === 201) {
                let data = [];
                for (let key in res.data) {
                    data.push({
                        key: key,
                        value: res.data[key]
                    })
                }
                setSummaryData(data);
            }
        })
    }

    function handleNonMappedData(id) {
        let sourceId = id ? id.toString() : sourceType.toString();
        getRequest(`https://devua.indianexpress.com/api/reports/getusers?source=${sourceId}&startdate=${dateFormat(startDate, 'Y-m-d', '-')}&enddate=${dateFormat(endDate, 'Y-m-d', '-')}`)
            .then(res => {
                res = res || [];
                setUserIdData(res);
            });
    }

    function handleMappedData(id) {
        let sourceId = id ? id.toString() : sourceType.toString();
        getRequest(`https://devua.indianexpress.com/api/reports/getmappedusers?source=${sourceId}&startdate=${dateFormat(startDate, 'Y-m-d', '-')}&enddate=${dateFormat(endDate, 'Y-m-d', '-')}`)
            .then(res => {
                res = res || [];
                setMappedUserData(res)
            })
    }

    function dayClicked(e) {
        let periodId;
        let el = e.target.closest('li');
        let ulElement = el.closest('ul');
        periodId = el.dataset.id;
        setPeriodValue(Number(periodId));
        onDeviceTypeClicked(periodId);
        let activeElement = ulElement.querySelector('.active');
        removeClass(activeElement, 'active');
        addClass(el, 'active');
    }

    function onDeviceTypeClicked(periodId) {
        let currentPeriodValue = typeof periodId === 'string' ? periodId : periodValue;
        let el = deviceRef.current;
        let allCheckBox = el.querySelectorAll('input');
        let checkedId = [];
        allCheckBox.forEach(item => {
            if (item.checked) {
                checkedId.push(item.dataset.value);
            }
        });
        setSourceType(checkedId);
        let url = [dataUrl(checkedId.toString(), 1, currentPeriodValue)];
        let allRequest = [];
        url.forEach(item => {
            allRequest.push(axios.get(item))
        });
        axios.all([...allRequest])
            .then(res => {
                let responseList = [];
                console.log(res);
                res.forEach(item => {
                    if (item.data.length) {
                        for (let i = 0; i < checkedId.length; i++) {
                            let eachSouceArray = item.data.filter((eachItem) => {
                                return eachItem['source'] == checkedId[i];
                            });
                            responseList.push(eachSouceArray)
                        }
                    }
                });
                //console.log(responseList);
                setLineChartData(responseList);
                handleNonMappedData(checkedId);
                handleMappedData(checkedId);
            }).then(()=>{

        })
    }

    function dataUrl(sourceType, typeId, periodId) {
        return `https://devua.indianexpress.com/api/reports/report?source=${sourceType}&type=${typeId}&period=${periodId}&startdate=${dateFormat(startDate, 'Y-m-d', '-')}&enddate=${dateFormat(endDate, 'Y-m-d', '-')}`;
    }

    function handlePieData() {
        axios.get('https://devua.indianexpress.com/api/reports/userssummary').then(response => {
                if (response.status === 200 || response.status === 201) {
                    let data = response.data[0];
                    console.log(data);
                    let UsersBySource = data['UsersBySource'][0];
                    let usersByType = data['usersByType'][0];
                    let formattedDataBySource = [];
                    let formattedDataByType = [];
                    for (let key in UsersBySource) {
                        formattedDataBySource.push({
                            name: key,
                            value: UsersBySource[key]
                        })
                    }
                    for (let key in usersByType) {
                        formattedDataByType.push({
                            name: key,
                            value: usersByType[key]
                        })
                    }
                    setDataBySource(formattedDataBySource);
                    setDataByType(formattedDataByType);
                    setTotalUser(data['totalusers']);
                }

            }
        )
    }

    function handleStartDate(date) {
        setStartDate(date)
    }

    function handleEndDate(date) {
        setEndDate(date)
    }

    function handleAnimatedSliding(e) {
        let el = e.target.closest('.collapsible');
        if (el) {
            toggleClass(el, 'active')
            let content = el.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }

    }

    function handleSearch(e) {
        e.preventDefault();
        let parentContainer = e.target.closest('.user-table');
        let input = e.target.querySelector('input')
        let value = input.value;

        mappedUserData.map(item => {
            let masterId = item['masterId'].toString();
            if (value) {
                if (masterId.indexOf(value) < 0) {
                    let mappedItem = item.usersMappedDetailsList;
                    for (let i = 0; i < mappedItem.length; i++) {
                        if (mappedItem[i]['userId'].indexOf(value) > -1 || mappedItem[i]['sourceName'].indexOf(value) > -1 || mappedItem[i]['userIdentifier'].indexOf(value) > -1) {
                            parentContainer.querySelector('#id-' + masterId).style.display = 'block';
                            return;
                        } else {
                            parentContainer.querySelector('#id-' + masterId).style.display = 'none';
                        }
                    }


                }
            } else {
                parentContainer.querySelector('#id-' + masterId).style.display = 'block';
            }
        })

    }

    function handleSimpleSearch(e) {
        e.preventDefault();
        let parentContainer = e.target.closest('.user-table');
        let input = e.target.querySelector('input')
        let value = input.value;
        if(value) {
            axios.get(`https://devua.indianexpress.com/api/reports/searchusers?keyword=${value}&source=${sourceType.toString()}`)
                .then((res) => {
                    if (res.status === 200 || res.status === 201){
                        setUserIdData(res.data)

                    }
                })
        }else{
            handleNonMappedData();
        }

    }

    function handleCalendarSubmit() {
        onDeviceTypeClicked();
        handleSummaryReportWithRange();

    }

    return (
        <div className='container-fluid'>
            <Headers/>
            <div className="App container-fluid ads-panel d-flex flex-row ">
                <SideBar/>
                <div className='chart-section'>
                    <div className='card source-card'>
                        <div className='card-header' ref={deviceRef}>

                            <div className="form-check">
                                <input type="checkbox" data-value={1} onChange={onDeviceTypeClicked}
                                       className="form-check-input" id="exampleCheck1" defaultChecked={true}/>
                                <label className="form-check-label" htmlFor="exampleCheck1">Web (Desktop)</label>
                            </div>

                            <div className="form-check">
                                <input type="checkbox" data-value={2} onChange={onDeviceTypeClicked}
                                       className="form-check-input" id="exampleCheck1"/>
                                <label className="form-check-label" htmlFor="exampleCheck1">Web (Mobile)</label>
                            </div>

                            <div className="form-check">
                                <input type="checkbox" data-value={3} onChange={onDeviceTypeClicked}
                                       className="form-check-input" id="exampleCheck1"/>
                                <label className="form-check-label" htmlFor="exampleCheck1">Android</label>
                            </div>

                            <div className="form-check">
                                <input type="checkbox" data-value={4} onChange={onDeviceTypeClicked}
                                       className="form-check-input" id="exampleCheck1"/>
                                <label className="form-check-label" htmlFor="exampleCheck1">IOS</label>
                            </div>
                            <div className='calendar-list'>
                                <div className="form-check">
                                    <label className="form-check-label">Start</label>
                                    <DatePicker maxDate={endDate} dateFormat="dd/MM/yyyy" selected={startDate}
                                                onSelect={handleStartDate}/>
                                </div>
                                <div className="form-check">
                                    <label className="form-check-label">End</label>
                                    <DatePicker minDate={startDate} maxDate={endDate} dateFormat="dd/MM/yyyy"
                                                selected={endDate} onSelect={handleEndDate}/>
                                </div>
                                <button className='btn bg-danger' onClick={handleCalendarSubmit}>Apply</button>
                            </div>
                        </div>

                    </div>
                    <div className='chart-card'>
                        <div className={'comparison'}>
                            Total User Count : {lineChartData.length}
                        </div>
                        <div className='times-list'>
                            <ul onClick={dayClicked}>

                                <li data-id='5' className='active'>
                                    Day
                                </li>
                                <li data-id='4'>
                                    Week
                                </li>
                                <li data-id='3'>
                                    Month
                                </li>
                                <li data-id='2'>
                                    Quarter
                                </li>
                                <li data-id='1'>
                                    Year
                                </li>
                            </ul>
                        </div>
                        <LineChartComponent
                            data={lineChartData}
                            interval={20}
                            xAxisValue={'perioddatetime'}/>
                    </div>
                    <div className='chart-card'>
                        <h4>Summary Report</h4>
                        <table className="table table-striped">
                            <thead>
                            <tr>

                                <th>type</th>
                                <th>Value</th>
                            </tr>
                            </thead>
                            <tbody>
                            {summaryData.map(item => {
                                if (item.value) {
                                    return <tr key={item.key}>
                                        <td>{item.key}</td>
                                        <td>{item.value}</td>
                                    </tr>
                                } else return null
                            })}
                            </tbody>
                        </table>
                    </div>
                    <div className='chart-card pie-chart'>
                        <div className='card total-card'>
                            <div className='card-body'>
                                Total User Till Now
                                <p>
                                    {totalUser}
                                </p>
                            </div>

                        </div>

                        <PieChartComponent type={1} width={380} height={250} data={dataBySource} dataKey={'value'}
                                           nameKey="name"
                                           cx="50%" cy="50%" outerRadius={50} colorsList={COLORS}/>
                        <PieChartComponent type={1} width={430} height={250} data={dataByType} dataKey={'value'}
                                           nameKey="name"
                                           cx="50%" cy="50%" outerRadius={100} innerRadius={50} colorsList={COLORS}/>
                    </div>
                    <div className=' chart-card user-table'>
                        <div className='d-flex justify-content-between'>
                            <h4>Total User : {userIdData.length}</h4>
                            <div className="search-container">
                                <form onSubmit={handleSimpleSearch}>
                                    <input type="text" placeholder="Search.." name="search"/>
                                    <button type="submit">Submit</button>
                                </form>
                            </div>
                        </div>
                        <div className='contents card-body' style={{'overflow': 'auto hidden'}}>
                            <table className="table table-striped">
                                <thead>
                                <tr>

                                    <th>UserId</th>
                                    <th>SourceName</th>
                                    <th>TypeName</th>
                                    <th>UserIdentifier</th>
                                    <th>createdDateTime</th>
                                    <th>updateDateTime</th>
                                    <th>statusId</th>
                                </tr>
                                </thead>
                                <tbody>
                                {userIdData.map((mappedItem, index) => {
                                    return <tr key={index}>
                                        <td>{mappedItem.userId}</td>
                                        <td>{mappedItem.sourceName}</td>
                                        <td>{mappedItem.typeName}</td>
                                        <td>{mappedItem.userIdentifier}</td>
                                        <td>{mappedItem.createDateTime}</td>
                                        <td>{mappedItem.updateDateTime}</td>
                                        <td>{mappedItem.statusId ? 'true' : 'false'}</td>
                                    </tr>
                                })}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className='chart-card user-table'>
                        <div className='d-flex justify-content-between'>
                            <h4>Total Mapped User : {mappedUserData.length}</h4>

                            <div className="search-container">
                                <form onSubmit={handleSearch}>
                                    <input type="text" placeholder="Search.." name="search"/>
                                    <button type="submit">Submit</button>
                                </form>
                            </div>
                        </div>
                        <div className=' card-header d-flex user-row-heading'>
                            <div><strong>masterId</strong></div>
                            <div><strong>createdDateTime</strong></div>
                            <div><strong>lastActiveDateTime</strong></div>
                            <div><strong>mappedTypes</strong></div>
                        </div>
                        <div className='card-columns d-flex flex-column'>
                            {mappedUserData.map(item => {
                                return <div className='card-body ' id={'id-' + item.masterId}
                                            onClick={handleAnimatedSliding} key={item.masterId}>
                                    <div className='d-flex collapsible user-row-data'>
                                        <div> {item.masterId}</div>
                                        <div> {item.createdDateTime}</div>
                                        <div> {item.lastActiveDateTime}</div>
                                        <div> {item.mappedTypes}</div>
                                    </div>
                                    {/*<button type="button" className="collapsible" onClick={handleAnimatedSliding}><strong>master Id : </strong> {item.masterId}</button>*/}
                                    <div className="content">
                                        <table className="table table-striped">
                                            <thead>
                                            <tr>

                                                <th>UserId</th>
                                                <th>SourceName</th>
                                                <th>TypeName</th>
                                                <th>UserIdentifier</th>
                                                <th>createdDateTime</th>
                                                <th>updateDateTime</th>
                                                <th>statusId</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {item.usersMappedDetailsList.map((mappedItem, index) => {
                                                return <tr key={index}>
                                                    <td>{mappedItem.userId}</td>
                                                    <td>{mappedItem.sourceName}</td>
                                                    <td>{mappedItem.typeName}</td>
                                                    <td>{mappedItem.userIdentifier}</td>
                                                    <td>{mappedItem.createdDateTime}</td>
                                                    <td>{mappedItem.updateDateTime}</td>
                                                    <td>{mappedItem.statusId ? 'true' : 'false'}</td>
                                                </tr>
                                            })}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default App;
